const SearchIcon = ({ width = "36px", height = "36px", fill="#52cc0a" }) => {
    return (
        <svg x="0px" y="0px" viewBox="0 0 40 40" xmlSpace="preserve" width={width} height={height} fill={fill}>
            <path d="M27.8,5.1c-6.3-6.3-16.5-6.3-22.7,0s-6.3,16.5,0,22.7c5.6,5.6,14.3,6.2,20.5,1.8l9.1,9.1c1.1,1.1,2.9,1.1,4,0s1.1-2.9,0-4l-9.1-9.1C34,19.4,33.4,10.7,27.8,5.1z M23.9,23.9C19.8,28,13.1,28,9,23.9S4.9,13.1,9,9c4.1-4.1,10.8-4.1,14.9,0S28,19.8,23.9,23.9z"/>
        </svg>
    );
};

export default SearchIcon;
